/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback, useRef } from 'react';

import { Channel, ChatProvider } from '@aicon-dev/caas-chat';
import { CloseOutline } from 'antd-mobile-icons';
import QuickPinchZoom, { make3dTransformValue } from 'react-quick-pinch-zoom';
import styled, { createGlobalStyle } from 'styled-components';

import { FileViewer } from '~/components/ui/FileViewer';
import { Modal } from '~/components/ui/ImagePinchZoom/Modal';
import { useLocationState } from '~/libs/hooks/useLocationState';
import { useAuthContext } from '~/modules/auth/context/AuthProvider';
import { useNavigate, useParams } from '~/router';

const GlobalStyle = createGlobalStyle`
  html, body {
    overflow: hidden;
  }
`;

type ExtentionType = 'share-document' | 'attachment' | 'gpt-rfi' | 'gpt-minutes';

export default function ChatChannel() {
  const { chatId } = useParams('/chat/:chatId');
  const navigate = useNavigate();
  const { userInfo } = useAuthContext();
  console.log('userInfo >>> ', userInfo);
  const [previewUrl, setPreviewUrl] = useLocationState('');

  const imgRef = useRef(null);
  const onUpdate = useCallback(({ x, y, scale }: any) => {
    const { current: img }: any = imgRef;

    if (img) {
      const value = make3dTransformValue({ x, y, scale });

      img.style.setProperty('transform', value);
    }
  }, []);

  const extentions: ExtentionType[] = ['attachment'];

  return (
    <ChatProvider
      extentions={extentions}
      channelUrl={chatId}
      renderFilePreview={(file) => <FileViewer files={[file]} />}
      shareDocument={{
        onClickReport: (data) => {
          navigate('/projects/:projectId/reports/:reportId', {
            params: { projectId: data.project_id, reportId: data._id },
          });
        },
        onClickMinutes(data) {
          navigate('/projects/:projectId/meetings/:meetingId', {
            params: { projectId: data.project_id, meetingId: data._id },
          });
        },
        onClickRfi(data) {
          console.log('rfi >>> ', data);
        },
        checkJoinedProject(projectId) {
          return !!userInfo?.projects.find((project) => project.project_id === projectId);
        },
      }}
      onChangeChannel={(url) => {
        navigate('/chat/:chatId', { params: { chatId: url } });
      }}
    >
      <GlobalStyle />

      {!!previewUrl && (
        <div onClick={() => navigate(-1)}>
          <Modal zIndex={12} onClick={() => navigate(-1)} header={false}>
            <Wrapper>
              <div
                style={{
                  padding: 12,
                  zIndex: 99,
                  position: 'fixed',
                  right: 0,
                }}
                onClick={() => navigate(-1)}
              >
                <CloseOutline color="white" fontSize="20px" />
              </div>
              <QuickPinchZoom onUpdate={onUpdate} key={previewUrl}>
                <div
                  ref={imgRef}
                  style={{
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100vw',
                    height: '100dvh',
                  }}
                >
                  <img src={previewUrl} style={{ width: '100vw', background: 'var(--white)' }} />
                </div>
              </QuickPinchZoom>
            </Wrapper>
          </Modal>
        </div>
      )}

      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100dvh',
          background: 'white',
        }}
      >
        <Channel
          onClose={() => navigate(-1)}
          onClickImage={(url) => setPreviewUrl(url)}
          onLeaveChannel={() => navigate(-2)}
        />
      </div>
    </ChatProvider>
  );
}

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;
